import { css } from '@emotion/react';

import COLORS from 'shared/styles/colors';
import theme from 'shared/styles/themes';

export default css({
  '&.module-scene': {
    borderRadius: '4px',
    border: `1px solid ${COLORS.PRIMARY100}`,
    backgroundColor: COLORS.NEUTRAL50,
    width: '100%',
  },
  '.module-scene': {
    '&__heading': {
      backgroundColor: COLORS.PRIMARY100,
      borderRadius: '4px 4px 0px 0px',
      borderBottom: `1px solid ${COLORS.PRIMARY100}`,
      padding: '8px 12px',
      textAlign: 'left',
    },
    '&__title': {
      textAlign: 'left',
      fontWeight: 600,
      marginBottom: 0,
      paddingTop: theme.space[1],
      fontSize: theme.fontSizes[3],
    },
    '&__content': {
      padding: '20px 12px 0 12px',
      marginBottom: 0,
    },
    '&__label p': {
      fontSize: theme.fontSizes[3],
    },
  },
});
